import React, { useContext, useEffect, useState } from "react";
// styled components
import { Table, Empty, Button, Input, Select } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// hooks
import { useGestionarPostulacionesBeps } from "../../../../hooks/useGestionarPostulacionesBeps";
import { ModalVerPropuesta } from "../../Convocatorias/GestionarPostulaciones/components/ModalVerPropuesta";
import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import { cantidadRegistros, EstadosPostulacion } from "../../../../utils/dataSelectOptions";
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalExportacion } from "../../../../components/Administrador/ModalExportacion/ModalExportacion";
import { TemplateContext } from "../../../../utils/template_context";
// components
// import { ModalVerPropuesta } from "./components/ModalVerPropuesta";
const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};
export const GestionarPostulacionesBesp = () => {
  const {
    allpostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    VerPropuesta,
    AceptarModalPropuesta,
    CancelarModal,
    postulacion,
    descargarArchivo,
    filtros,
    setFiltros,
    cantidadpáginas,
    totalregistros,
    cambiarCantidadPaginas,
    limpiarFiltros,
    buscarpostulaciones,
  } = useGestionarPostulacionesBeps();
  const context = useContext(TemplateContext);
  const [countSubsanable, setCountSubsanable] = useState<number>(0);
  const [idPostulacion, setIdPostulacion] = useState<number>();
  const [observaciones, setObservaciones] = useState<any>(null);

  const handlechangecheck = (e: any, datos: any, index: number, postulacion: PostulacionModel) => {
    let todosJSON = JSON.parse(JSON.stringify(allpostulaciones));
    for (var i in todosJSON) {
      //console.log(todosJSON[i].id_postulacion);
      if (todosJSON[i].id_postulacion === postulacion.id_postulacion) {
        if (e.target.name === "checksubsanable") {
          postulacion.documentos_administrativos[index].checksubsanable = true;
          postulacion.documentos_administrativos[index].checkaceptar = false;
          postulacion.documentos_administrativos[index].checkcancelar = false;
          todosJSON[i].documentos_administrativos[index].checksubsanable = true;
          todosJSON[i].documentos_administrativos[index].checkaceptar = false;
          todosJSON[i].documentos_administrativos[index].checkcancelar = false;
        }
        if (e.target.name === "checkaceptar") {
          postulacion.documentos_administrativos[index].checksubsanable = false;
          postulacion.documentos_administrativos[index].checkaceptar = true;
          postulacion.documentos_administrativos[index].checkcancelar = false;
          todosJSON[i].documentos_administrativos[index].checksubsanable = false;
          todosJSON[i].documentos_administrativos[index].checkaceptar = true;
          todosJSON[i].documentos_administrativos[index].checkcancelar = false;
        }
        if (e.target.name === "checkrechazado") {
          postulacion.documentos_administrativos[index].checksubsanable = false;
          postulacion.documentos_administrativos[index].checkaceptar = false;
          postulacion.documentos_administrativos[index].checkcancelar = true;
          todosJSON[i].documentos_administrativos[index].checksubsanable = false;
          todosJSON[i].documentos_administrativos[index].checkaceptar = false;
          todosJSON[i].documentos_administrativos[index].checkcancelar = true;
        }
      }
    }
    return setAllPostulaciones(todosJSON);
  };
  useEffect(() => {
    cargarTodasPostulaciones(true);
  }, []);
  const columns: any = [
    {
      title: "No.",
      width: 100,
      key: "idx",
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) =>
        <div>{index + 1}</div>
      ,
    },
    {
      title: "Nombre participante",
      width: 200,
      fixed: context.device === "md" ? "left" : false,
      dataIndex: "nombre_participante",
      key: "nombre_participante",
    },
    {
      title: "Código",
      width: 120,
      render: (datos: any) => {
        return (
          <span>{datos.radicado}</span>
        );
      },
      // dataIndex: "codigo",
      // key: "codigo",
    },
    {
      title: "Cédula",
      width: 120,
      dataIndex: "numero_documento_participante",
      key: "numero_documento_participante",
    },
    {
      title: "Estado",
      width: 100,
      render: (datos: any) => {
        return (
          <span style={{ color: coloresEstado[datos.estado] }}>{datos.estado}</span>
        );
      },
    },
    {
      title: "Teléfono",
      width: 169,
      dataIndex: "telefono_celular",
      key: "telefono_celular",
    },
    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12 justify-content-center">
            <Button
              onClick={() => {
                  setIdPostulacion(datos.id_postulacion)
                  VerPropuesta(datos)
                }
              }
              className="no-margin button-azul-ghost font-family-Montserrat-Medium"
            >
              Ver Más
            </Button>
          </div>
        </div>
      ),
    },
  ];
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  }
  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Aceptados", value: "Aceptado" },
    { id: 2, nombre: "No Aceptados", value: "Rechazado" },
    { id: 3, nombre: "Todos los postulados", value: "Todos" }
  ]
  const [openModal, setOpenModal] = useState(false);
  const openModalExportar = () => setOpenModal(true);
  // console.log(datosFiltrados)


  const routes = [{ nombre: "Postulaciones" }, { nombre: "BEPS" }];
  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="titulo-proyectos font-family-Montserrat-SemiBold font-size-14px">
          Postulaciones BEPS
        </div>
        <div className="sombra_card" style={{ marginBottom: "20px", marginTop: "16px" }}>
          <div className="">
            <div
              className="header_card"
            >
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">Filtrar beps</div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="row">
                    <div className="col-12 pb-2">
                      <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">Filtrar por palabra</span>
                    </div>
                    <div className="col-12 pb-2">
                      <Input
                        value={filtros.buscarpalabra}
                        onChange={(e) => setFiltros({ ...filtros, buscarpalabra: e.target.value })}
                        suffix={
                          <SearchOutlined className="font-color-051923bf" />
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="row">
                    <div className="col-12 pb-2 ">
                      <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">Filtrar Estado</span>
                    </div>
                    <div className="col-12">
                      <Select
                        style={{ width: "100%" }}
                        value={filtros.estado}
                        placeholder="Seleccionar..."
                        onChange={(value) => setFiltros({ ...filtros, estado: value })}
                      >
                        {EstadosPostulacion.map(({ value, text, key }) => (
                          <Select.Option key={key} value={value}>
                            {text}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_card justify-content-flex-end">
              <Button className="button-azul-ghost m-0" onClick={limpiarFiltros}>
                LIMPIAR FILTROS
              </Button>
              <Button className="button-azul-radius m-0" onClick={buscarpostulaciones}>
                BUSCAR
              </Button>
            </div>
          </div>
        </div>
        <div className="row-shadow mb-3" >
          <div className="row">
            <div className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular" style={{ paddingBottom: "0%" }}>
              {/* Subsanar documentos Beps */}
              Lista de postulados convocatorias BEPS
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end align-content-center align-items-center mb-3">
              <div>
                Total: <span className="font-color-F28C02">{totalregistros}</span>
              </div>
              <div className="d-flex registos-adminconvocatoria" style={{ width: 200 }}>
                <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                  Registros por página
                </label>
                <Dropdown

                  className="d-flex select-registros-adminconvocatoria no-margin"
                  defaultValue={cantidadpáginas}
                  options={cantidadRegistros}
                  icon={
                    <Icon className="font-color-051923bf iconos-dropdown-global " name="angle down" />
                  }
                  onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadpáginas }}
                dataSource={allpostulaciones}
                columns={columns}
                size="small"
                bordered={false}
              />
            </div>
          </div>
        </div>

      </div>
      <div className="container-sticky-footer">
        <div className="row">
          <div className="col-6 d-flex justify-content-md-end">
            {/* <Button className="button-blanco-radius">ATRÁS</Button> */}
          </div>
          <div className="col-6 d-flex justify-content-flex-end">
            <Button className="button-azul-radius" onClick={openModalExportar}>
              Exportar datos
            </Button>
          </div>
        </div>
      </div>
      {/*
<ModalExportar openModal={openModal} setOpenModal={setOpenModal} />
*/}
      {openModal &&
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Beps"
          consulta="1"
        />
      }
      <ModalVerPropuesta
        modal={modal}
        AceptarModal={AceptarModalPropuesta}
        postulacion={postulacion}
        descargarArchivo={descargarArchivo}
        setAllPostulaciones={setAllPostulaciones}
        allpostulaciones={allpostulaciones}
        CancelarModal={CancelarModal}
        isBeps={true}
        lineasConvocatoria={[]}
        setCountSubsanable={setCountSubsanable}
        countSubsanable={countSubsanable}
        setIdPostulacion={setIdPostulacion}
        idPostulacion={idPostulacion}
        setObservaciones={setObservaciones}
        observaciones={observaciones}
      />
    </div>
  );
};

